export const GET_PROFILE = 'GET_PROFILE'
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL'

export const GET_CONFIGURATION = 'GET_CONFIGURATION'
export const GET_CONFIGURATION_SUCCESS = 'GET_CONFIGURATION_SUCCESS'
export const GET_CONFIGURATION_FAIL = 'GET_CONFIGURATION_FAIL'

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const CHANGE_LANGUAGE_COMPLETE = 'CHANGE_LANGUAGE_COMPLETE'